import { Stack, styled } from "@mui/material";

export const LightBanner = styled(Stack)(({ theme }) => ({
  backgroundColor: "#ebf0f8",
  color: theme.palette.primary.main,
  border: "1px solid #c8d4e7",
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  borderRadius: 4,
  padding: 16,
}));
